<template>
  <div>
    <syarat-ketentuan-desktop v-if="!isMobile" />
    <syarat-ketentuan-mobile v-else class="skMobile" />
  </div>
</template>
<script>
import SyaratKetentuanDesktop from "./Desktop/SyaratKetentuan-Desktop.vue";
import SyaratKetentuanMobile from "./Mobile/SyaratKetentuan-Mobile.vue";
export default {
  components: { SyaratKetentuanDesktop, SyaratKetentuanMobile },
  computed: {
    isMobile() {
      if (window.innerWidth >= 500) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.Hero {
  width: 100%;
  margin-top: -80px;
  object-fit: contain;
}
.Hero-Text {
  width: 763px;
  height: 56px;
  margin: 101px 418px 0 419px;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: absolute;
}
.skMobile {
  margin-left: 2rem;
  margin-right: 3rem;
}
</style>
